import React, { memo, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import cn from 'classnames';

import { routes } from '@constants/routes';

import styles from './menuSwitcher.module.scss';

export interface IMenuSwitcherProps {
	containerStyles?: React.CSSProperties;
	isMapMode: boolean;
	isAdminPanelAccess: boolean;
	isMapAccess: boolean;
	isBothAccess: boolean;
}

function MenuSwitcher({
	containerStyles,
	isMapMode,
	isAdminPanelAccess,
	isMapAccess,
	isBothAccess,
}: IMenuSwitcherProps) {
	const navigate = useNavigate();
	const location = useLocation();

	const menuItems = useMemo(() => [
		{
			name: 'Map',
			path: routes.map.index,
			disabled: !(isMapAccess || isBothAccess),
		},
		{
			name: 'Admin',
			path: routes.adminPanel.index,
			disabled: !(isAdminPanelAccess || isBothAccess),
		},
	], [isAdminPanelAccess, isBothAccess, isMapAccess]);

	const currentPage: string | undefined = location?.pathname;

	const onMenuItemClick = (path: string) => () => {
		if (currentPage !== path) {
			navigate(path);
		}
	};

	return (
		<div
			className={cn(styles.menuSwitcher, {
				[styles.withOuterShadow]: isMapMode,
			})}
			style={containerStyles}
		>
			{
				menuItems.map((item, index) => {
					if (item.disabled) {
						return null;
					}

					return (
						<div
							key={index}
							className={cn(styles.menuSwitcher__item, {
								[styles.active]: currentPage?.includes(item.path),
							})}
							onClick={onMenuItemClick(item.path)}
						>
							<span>{item.name}</span>
						</div>
					);
				})
			}
		</div>
	);
}

export default memo(MenuSwitcher);
